/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChronicDiseaseFilter } from './ChronicDiseaseFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type ChronicDiseaseRequest = {
    filter?: ChronicDiseaseFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: ChronicDiseaseRequest.exposeType;
}

export namespace ChronicDiseaseRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
